import { PurchaseConfirmModal } from '@/components/PurchaseConfirmModal';
import { useLocale } from '@/context/LocaleContext';

interface BuyTitleModalProps {
  open: boolean;
  title: string;
  color: string;
  buyColor: boolean;
  price: number;
  balance: number | null;
  balanceLoading: boolean;
  onConfirm: () => void;
  onClose: () => void;
  confirming?: boolean;
}

function isDarkPreview(hex: string): boolean {
  const raw = hex.replace('#', '').trim();
  if (raw.length !== 6) return false;
  const r = Number.parseInt(raw.slice(0, 2), 16);
  const g = Number.parseInt(raw.slice(2, 4), 16);
  const b = Number.parseInt(raw.slice(4, 6), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 < 0.45;
}

export function BuyTitleModal({
  open,
  title,
  color,
  buyColor,
  price,
  balance,
  balanceLoading,
  onConfirm,
  onClose,
  confirming,
}: BuyTitleModalProps) {
  const { t } = useLocale();

  return (
    <PurchaseConfirmModal className="silk-modal--aaa"
      open={open}
      headerTitle={t('tm_buy_title_modal_title')}
      price={price}
      balance={balance}
      balanceLoading={balanceLoading}
      confirming={confirming}
      onConfirm={onConfirm}
      onClose={onClose}
    >
      <p className="tm-buy-modal-extra">
        <strong>{t('tm_buy_title_label')}</strong>{' '}
        <span
          className={`tm-buy-modal-title-preview${isDarkPreview(color) ? ' title-text--dark' : ''}`}
          style={{ color }}
        >
          {title}
        </span>
      </p>
      {buyColor ? (
        <p className="tm-buy-modal-extra">
          <strong>{t('tm_buy_includes')}</strong> {t('tm_buy_includes_title_color')}
        </p>
      ) : null}
    </PurchaseConfirmModal>
  );
}
